var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7433 11.5133H13.9433V6.60998C13.9433 6.17735 13.5926 5.82664 13.16 5.82664H9.94666L7.71 3.58664C7.56189 3.43978 7.3619 3.35715 7.15333 3.35664H3.06333V2.55664H7.15333C7.57341 2.55606 7.97643 2.72278 8.27333 3.01998L10.2733 5.01998H13.1567C13.5766 5.01998 13.9793 5.18679 14.2762 5.48372C14.5732 5.78066 14.74 6.18338 14.74 6.60331L14.7433 11.5133Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9333 13.4433H2.66666C1.89239 13.4396 1.26665 12.8109 1.26666 12.0366V4.17998H5.75C6.17071 4.17953 6.57407 4.3476 6.87 4.64664L8.87 6.64664H11.75C12.1705 6.64664 12.5737 6.81391 12.8708 7.11157C13.1678 7.40922 13.3342 7.81281 13.3333 8.23331V12.0366C13.3333 12.8109 12.7076 13.4396 11.9333 13.4433ZM2.05666 12.0366V4.97998H5.75C5.95771 4.97991 6.15687 5.06269 6.30333 5.20998L8.54333 7.44998H11.7533C12.186 7.44998 12.5367 7.80069 12.5367 8.23331V12.0366C12.5367 12.3704 12.2671 12.6415 11.9333 12.6433H2.66666C2.50519 12.6442 2.35002 12.5807 2.23553 12.4668C2.12103 12.3529 2.05666 12.1981 2.05666 12.0366Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileFolder);
export default __webpack_public_path__ + "static/media/file-folder.7735c9b9ecacb9a8ad19ede3e5e58cee.svg";
export { ForwardRef as ReactComponent };